<template lang="pug">
  div.alinhamento(:class="{'color-background': color}")
    el-collapse(v-model='abaAtiva', accordion)
      el-collapse-item(
        name="colapse",
        :title="titulo",
        :class="{'recuo-texto': recuo}"
      )
        div(v-for="informacao in informacoes")
          app-display(
            :label="informacao.label",
            :content="informacao.data",
            :marginBottom="informacao.marginBottom"
          )

</template>

<script>
import AppDisplay from './AppDisplay'

export default {

  components: {
    AppDisplay
  },

  props: {
    // Prop responsável por definir o título que será exibido no colapse
    titulo: {
      type: String,
      required: true
    },

    // Prop responsável por definir se haverá cor azul para o colapse
    color: {
      type: Boolean,
      default: false
    },

    // Prop responśável para definir se haverá recuo do texto referente ao colapse
    recuo: {
      type: Boolean,
      default: true
    },

    // Prop responśável para trazer as informações do cadastro
    informacoes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      abaAtiva: ['colapse']
    }
  }

}
</script>

<style lang="scss" scoped>

  .alinhamento {
    align-items: left;
    text-align: left;
  }

  .recuo-texto {
    text-indent:1em
  }

</style>



// WEBPACK FOOTER //
// src/components/AppDisplayColapse.vue